module.exports = __webpack_public_path__ + "static/credit_andorra_payment_gateway-9f39a99afd8771194a28747a738a7fe0.svg";